<template>
  <v-hover v-slot="{ hover }">
    <v-card
      color="grey lighten-4"
      rounded="lg"
      :elevation="hover ? 10 : 5"
      class="fill-height overflow-hidden"
    >
      <div class="d-flex flex-column fill-height">
        <div
          style="height: 100px; display: flex; justify-content: center; align-items: center;"
        >
          <img
            src="@/assets/img/insiders/device.png"
            :width="50"
            alt="Insiders device"
          >
        </div>
        <v-divider />
        <div class="d-flex flex-column justify-center align-items-center pa-4 grey--text text--darken-2">
          <div class="text-center">
            <span class="font-weight-medium">
              {{ device.human_id }}
            </span>
          </div>
          <div class="text-center text-caption">
            {{ device.serial_number }}
          </div>
        </div>
        <v-divider />
      </div>
    </v-card>
  </v-hover>
</template>
<script>

export default {
  name: 'DeviceCard',
  props: {
    device: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {}
}
</script>
